/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlAnswerResponse {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlAnswerResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlAnswerResponse>): ComplianceAssessmentControlAnswerResponse {
        let obj = Object.assign(new ComplianceAssessmentControlAnswerResponse(), model);
        ComplianceAssessmentControlAnswerResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlAnswerResponse>): ComplianceAssessmentControlAnswerResponse {
        if (!model) return null;
        return ComplianceAssessmentControlAnswerResponse.newInstance(<ComplianceAssessmentControlAnswerResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlAnswerResponse) {
        if (!obj) return;

        models.ComplianceAssessmentControlAnswerResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlAnswerResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlAnswerResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_control_evidence) {
            for (let val of this.assessment_control_evidence) {
                models.ComplianceAssessmentControlEvidence.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID for the assessment control ID
     */
    assessment_control_id: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Status of assessment control
     */
    assessment_control_status: models.ComplianceControlStatus;

    assessment_control_evidence: Array<models.ComplianceAssessmentControlEvidence>;

    /**
     * Unique URI for the compliance control
     */
    compliance_control_uri: string;

}
